const centiOverview = [
  {
      "city": "New York City",
      "country": "USA",
      "centiMillionaires": "775",
      "billionaires": "62",
      "centiGrowth": "22"
  },
  {
      "city": "The Bay Area",
      "country": "USA",
      "centiMillionaires": "692",
      "billionaires": "69",
      "centiGrowth": "50"
  },
  {
      "city": "Los Angeles",
      "country": "USA",
      "centiMillionaires": "504",
      "billionaires": "44",
      "centiGrowth": "17"
  },
  {
      "city": "London",
      "country": "UK",
      "centiMillionaires": "388",
      "billionaires": "36",
      "centiGrowth": "12"
  },
  {
      "city": "Beijing",
      "country": "China",
      "centiMillionaires": "365",
      "billionaires": "44",
      "centiGrowth": "60"
  },
  {
      "city": "Shanghai",
      "country": "China",
      "centiMillionaires": "332",
      "billionaires": "40",
      "centiGrowth": "63"
  },
  {
      "city": "Singapore",
      "country": "Singapore",
      "centiMillionaires": "330",
      "billionaires": "27",
      "centiGrowth": "55"
  },
  {
      "city": "Hong Kong",
      "country": "Hong Kong (SAR China)",
      "centiMillionaires": "305",
      "billionaires": "34",
      "centiGrowth": "24"
  },
  {
      "city": "Chicago",
      "country": "USA",
      "centiMillionaires": "286",
      "billionaires": "22",
      "centiGrowth": "6"
  },
  {
      "city": "Paris and Ile-de-France",
      "country": "France",
      "centiMillionaires": "280",
      "billionaires": "20",
      "centiGrowth": "45"
  },
  {
      "city": "Tokyo",
      "country": "Japan",
      "centiMillionaires": "275",
      "billionaires": "15",
      "centiGrowth": "25"
  },
  {
      "city": "Geneva (canton)",
      "country": "Switzerland",
      "centiMillionaires": "262",
      "billionaires": "14",
      "centiGrowth": "35"
  },
  {
      "city": "Houston",
      "country": "USA",
      "centiMillionaires": "255",
      "billionaires": "18",
      "centiGrowth": "47"
  },
  {
      "city": "Zurich (canton)",
      "country": "Switzerland",
      "centiMillionaires": "230",
      "billionaires": "11",
      "centiGrowth": "30"
  },
  {
      "city": "Mumbai",
      "country": "India",
      "centiMillionaires": "224",
      "billionaires": "27",
      "centiGrowth": "80"
  },
  {
      "city": "Dubai",
      "country": "UAE",
      "centiMillionaires": "210",
      "billionaires": "15",
      "centiGrowth": "78"
  },
  {
      "city": "Moscow",
      "country": "Russian Federation",
      "centiMillionaires": "205",
      "billionaires": "23",
      "centiGrowth": "5"
  },
  {
      "city": "Sydney",
      "country": "Australia",
      "centiMillionaires": "198",
      "billionaires": "20",
      "centiGrowth": "60"
  },
  {
      "city": "Toronto",
      "country": "Canada",
      "centiMillionaires": "192",
      "billionaires": "18",
      "centiGrowth": "52"
  },
  {
      "city": "Seoul",
      "country": "South Korea",
      "centiMillionaires": "185",
      "billionaires": "19",
      "centiGrowth": "25"
  },
  {
      "city": "Monaco",
      "country": "Monaco",
      "centiMillionaires": "178",
      "billionaires": "22",
      "centiGrowth": "72"
  },
  {
      "city": "Miami",
      "country": "USA",
      "centiMillionaires": "165",
      "billionaires": "12",
      "centiGrowth": "57"
  },
  {
      "city": "Shenzhen",
      "country": "China",
      "centiMillionaires": "154",
      "billionaires": "22",
      "centiGrowth": "88"
  },
  {
      "city": "Frankfurt",
      "country": "Germany",
      "centiMillionaires": "148",
      "billionaires": "14",
      "centiGrowth": "35"
  },
  {
      "city": "Milan and Lombardy",
      "country": "Italy",
      "centiMillionaires": "140",
      "billionaires": "15",
      "centiGrowth": "40"
  },
  {
      "city": "Delhi",
      "country": "India",
      "centiMillionaires": "126",
      "billionaires": "17",
      "centiGrowth": "85"
  },
  {
      "city": "Seattle",
      "country": "USA",
      "centiMillionaires": "123",
      "billionaires": "10",
      "centiGrowth": "50"
  },
  {
      "city": "Dallas",
      "country": "USA",
      "centiMillionaires": "120",
      "billionaires": "14",
      "centiGrowth": "52"
  },
  {
      "city": "Melbourne",
      "country": "Australia",
      "centiMillionaires": "118",
      "billionaires": "10",
      "centiGrowth": "67"
  },
  {
      "city": "Greenwich and Darien",
      "country": "USA",
      "centiMillionaires": "112",
      "billionaires": "8",
      "centiGrowth": "54"
  },
  {
      "city": "Boston",
      "country": "USA",
      "centiMillionaires": "106",
      "billionaires": "8",
      "centiGrowth": "32"
  },
  {
      "city": "Hangzhou",
      "country": "China",
      "centiMillionaires": "98",
      "billionaires": "12",
      "centiGrowth": "95"
  },
  {
      "city": "Rome and Lazio",
      "country": "Italy",
      "centiMillionaires": "94",
      "billionaires": "11",
      "centiGrowth": "35"
  },
  {
      "city": "Austin",
      "country": "USA",
      "centiMillionaires": "88",
      "billionaires": "9",
      "centiGrowth": "84"
  },
  {
      "city": "Tel Aviv",
      "country": "Israel",
      "centiMillionaires": "86",
      "billionaires": "11",
      "centiGrowth": "50"
  },
  {
      "city": "Washington, D.C.",
      "country": "USA",
      "centiMillionaires": "85",
      "billionaires": "12",
      "centiGrowth": "32"
  },
  {
      "city": "Amsterdam",
      "country": "Netherlands",
      "centiMillionaires": "85",
      "billionaires": "8",
      "centiGrowth": "62"
  },
  {
      "city": "Luxembourg City",
      "country": "Luxembourg",
      "centiMillionaires": "82",
      "billionaires": "6",
      "centiGrowth": "30"
  },
  {
      "city": "Taipei",
      "country": "Taiwan (Chinese Taipei)",
      "centiMillionaires": "82",
      "billionaires": "15",
      "centiGrowth": "25"
  },
  {
      "city": "Munich",
      "country": "Germany",
      "centiMillionaires": "80",
      "billionaires": "10",
      "centiGrowth": "40"
  },
  {
      "city": "Vancouver",
      "country": "Canada",
      "centiMillionaires": "72",
      "billionaires": "6",
      "centiGrowth": "67"
  },
  {
      "city": "Madrid",
      "country": "Spain",
      "centiMillionaires": "70",
      "billionaires": "8",
      "centiGrowth": "30"
  },
  {
      "city": "Osaka",
      "country": "Japan",
      "centiMillionaires": "70",
      "billionaires": "5",
      "centiGrowth": "28"
  },
  {
      "city": "Guangzhou",
      "country": "China",
      "centiMillionaires": "68",
      "billionaires": "9",
      "centiGrowth": "76"
  },
  {
      "city": "Vienna",
      "country": "Austria",
      "centiMillionaires": "66",
      "billionaires": "7",
      "centiGrowth": "52"
  },
  {
      "city": "Riyadh",
      "country": "Saudi Arabia",
      "centiMillionaires": "65",
      "billionaires": "9",
      "centiGrowth": "85"
  },
  {
      "city": "Istanbul",
      "country": "Türkiye",
      "centiMillionaires": "64",
      "billionaires": "10",
      "centiGrowth": "35"
  },
  {
      "city": "Stockholm",
      "country": "Sweden",
      "centiMillionaires": "64",
      "billionaires": "12",
      "centiGrowth": "28"
  },
  {
      "city": "Nice",
      "country": "France",
      "centiMillionaires": "63",
      "billionaires": "6",
      "centiGrowth": "55"
  },
  {
      "city": "Perth",
      "country": "Australia",
      "centiMillionaires": "63",
      "billionaires": "8",
      "centiGrowth": "57"
  }
];

const centiWorldData = [
  {
      "city": "World",
      "country": "",
      "centiMillionaires": "28420",
      "billionaires": "2350",
      "centiGrowth": "38"
  }
];

export {centiOverview, centiWorldData};